import { useEffect, useState, type ReactElement } from "react";

export default function FeedPage(): ReactElement {
  const [xml, setXml] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadFeed() {
      try {
        const res = await fetch("/feed.xml");
        if (!res.ok) {
          throw new Error(`HTTP ${String(res.status)}`);
        }
        const text = await res.text();
        setXml(text);
        setLoading(false);
      } catch (err: unknown) {
        setError(`Failed to load feed: ${err instanceof Error ? err.message : String(err)}`);
        setLoading(false);
      }
    }

    void loadFeed();
  }, []);

  if (loading) return <div>Loading RSS feed…</div>;
  if (error) return <div>Failed to load feed: {error}</div>;

  return (
    <div style={{ padding: "1rem" }}>
      <h1>RSS Feed</h1>
      <p>
        This is the contents of <code>feed.xml</code> currently being served. Go
        to{" "}
        <a href="feed.xml" rel="nofollow" target="_blank">
          feed.xml
        </a>{" "}
        for raw feed.
      </p>
      <pre
        style={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          maxHeight: "70vh",
          overflow: "auto",
          border: "1px solid #ccc",
          padding: "1rem",
          borderRadius: "8px",
          fontSize: "0.9rem",
        }}
      >
        <code>{xml}</code>
      </pre>
    </div>
  );
}
